export default __webpack_public_path__ + "static/media/Heart-Outline.d487033b.svg";